import React from 'react';
import './AboutUs.css';
import videoBg from "../components/asstes/aboutuscontruction.mp4";

const AboutUs = () => {
  return (
    <div className="about-us-container">
      {/* Overlay */}
      <div className="about-us-overlay"></div>

      {/* Content */}
      <div className="about-us-content">
        {/* Left Section */}
        <div className="about-us-left">
          <div>
            <h1 className="about-us-heading">About Us</h1>
            <p className="about-us-paragraph">
              Maniraj Builder is a leading residential and commercial construction company based in Dhanbad, Jharkhand, committed to delivering high-quality housing and commercial projects.
            </p>
            <ul className="about-us-list">
              <li>
                <strong>Completed Projects:</strong> Successfully delivered <strong>"Maniraj Ghrih"</strong>, a well-planned residential project located in Nawadih, Hirak Road, Dhanbad.
              </li>
              <li>
                <strong>Ongoing Development:</strong> Currently developing <strong>"Maniraj Aalay"</strong>, a residential and commercial project near the Survey Office, Dhanbad, featuring well-designed commercial spaces, including shops.
              </li>
              <li>
                <strong>Future Expansion:</strong> With a vision to provide affordable housing equipped with modern amenities, the company is set to launch new projects in the near future.
              </li>
            </ul>
           
          </div>
        </div>

        {/* Right Section with Video */}
        <div className="about-us-right">
          <video className="about-us-video" src={videoBg} type="video/mp4" autoPlay loop muted playsInline></video>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
